document.addEventListener("DOMContentLoaded", function () {

  const images = document.querySelectorAll(
    'product-gallery img, .product-media-container img, .media img'
  );


  console.log("Found images:", images.length);


  if(images.length === 0) return;


  const lightbox = document.createElement("div");

  lightbox.innerHTML = `
    <div class="zoom-overlay">
      <img class="zoom-image">
      <span class="zoom-close">×</span>
    </div>
  `;


  document.body.appendChild(lightbox);


  const overlay = lightbox.querySelector(".zoom-overlay");
  const zoomImage = lightbox.querySelector(".zoom-image");
  const close = lightbox.querySelector(".zoom-close");


  images.forEach(function(img){

    img.style.cursor="zoom-in";


    img.addEventListener("click",function(e){

      e.preventDefault();
      e.stopPropagation();


      zoomImage.src=this.src;

      overlay.classList.add("show");


    });


  });



  close.onclick=function(){

    overlay.classList.remove("show");

  };


  overlay.onclick=function(e){

    if(e.target===overlay){

      overlay.classList.remove("show");

    }

  };


});